export default __webpack_public_path__ + "static/media/Roboto-Medium.987ab511.ttf";